import { msg } from "@lingui/core/macro";

export const expiryDateRuleMessages = {
	name: msg({ message: "Fixed Expiry Date" }),
	description: msg({ message: "Permit Expiry Date is Pre-Set" }),
	errors: {
		dateMismatch: msg({ message: "Permit must expire on {date}" }),
		noEndDate: msg({ message: "Permit must have an end date" }),
	},
} as const;
